
export const TableCol = () => {

  return [
    {
      key: 'name',
      dataIndex: 'name',
      title: 'Course',
    },
    {
      key: 'credit',
      dataIndex: 'credit',
      title: 'Credits'
    }
  ];
};
